import api from '@/api'
import { firebaseLogin, preloadFirebase, signOutFirebase } from '@/utils/firebaseAuth'

// The Google redirect login, also the fallback when the Firebase one can't run
export function googleRedirect() {
    const here = window.location.pathname + window.location.search
    window.location.assign('/auth/google?return=' + encodeURIComponent(here))
}
const UserModule = {
    state: () => ({ auth: {}, isLoggedIn: false }),
    mutations: {
        UPDATE_AUTH(state, payload){
            state.isLoggedIn = true
            state.auth = payload.data
        },
        LOGOUT_AUTH(state) {
            state.auth = {},
            state.isLoggedIn = false
        }
    },
    actions: {
        async getUser(context) {
            try {
                const payload = await api.UserApi.getUser()
                context.commit("UPDATE_AUTH", payload);
                context.dispatch("favorites/preload", null, { root: true });
            } catch (error) {
                // A token the server no longer accepts shouldn't be retried on every page
                if (error.response?.status === 401) {
                    localStorage.removeItem('_token')
                }
                throw error
            }
        },
        // Log in with Firebase and stay on this page
        async login({ dispatch }) {
            try {
                const firebase = await firebaseLogin()
                if (!firebase) return googleRedirect()

                dispatch('notification/showNotification', { message: 'Logging in…', type: 'info' }, { root: true })
                const { token } = await api.UserApi.loginWithFirebase(firebase)
                if (!token) throw new Error('No session')
                localStorage.setItem('_token', token)
                window.location.reload()
            } catch (error) {
                // Closing the popup is a choice, not a failure
                if (['auth/popup-closed-by-user', 'auth/cancelled-popup-request'].includes(error.code)) return
                googleRedirect()
            }
        },
        preloadLogin() {
            preloadFirebase().catch(() => {})
        },
        async logoutUser(context) {
            const payload = await api.UserApi.logoutUser()
            await signOutFirebase().catch(() => {})
            context.commit("LOGOUT_AUTH");
            // Reload so nothing from the signed-in session lingers on the page
            window.location.assign('/');
        }
    },
    getters: {},
    namespaced: true
}
export default UserModule 